import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const ScanForm = React.lazy(() => import('components/Scan/Form/Form'));

function ScreensScanForm() {
  return (
    <BaseLayout>
      <DocumentTitle>Scanning</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <ScanForm />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensScanForm;
